import {
  OPEN_URL,
} from '../main/payment/constants';

const windowMiddleware = () => next => (action) => {
  next(action);
  switch (action.type) {
    case OPEN_URL:
      window.location.href = action.payload;
      break;
    default:
      break;
  }
};

export default windowMiddleware;
